export default __webpack_public_path__ + "static/media/Shot_29.0000.d31756e2.png";